const WORDS = ["Moments not poses", "Booking 2027 — Italy · Denmark · Sweden", "Shot on feeling", "Shadow & grain", "TapeShift Weddings", "Forever, unposed"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-8 md:py-10 bg-[#0A0A0A]" data-testid="marquee-band">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif font-light text-3xl md:text-5xl tracking-tight text-[#F5F4F0]/80 whitespace-nowrap px-8 md:px-12">
                  {w}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#C9A26B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
